import { createProviders } from '@hs/shared';
import { Toast, toast } from '@heroui/react';
import { store } from '@/stores/store';
import { trpc, trpcClient, trpcProxyClient } from '@/lib/trpc';
import type { ErrorInfo } from '@hs/shared';
import { ThemeProvider } from '@/components/ThemeProvider';

/**
 * 应用根 Provider
 * 
 * ✅ 使用 shared 包的工厂函数创建 Providers
 * 
 * 组合了以下 Provider：
 * - tRPC Provider: API 请求
 * - React Query Provider: 数据缓存
 * - Redux Provider: 全局状态
 * - AuthProvider: 认证服务（用户信息获取 + 跨标签页同步）
 * - TokenRefreshHandler: Token 自动刷新
 * - Toaster: 错误提示（由业务模块提供）
 * 
 * 注意：HeroUI 组件按需使用即可
 */
// 创建 Providers 组件
const BaseProviders = createProviders({
  store,
  trpc: trpc as any,
  trpcClient,
  trpcProxyClient,
  loginPath: '/login',
  isHomeApp: true, // ✅ home 应用：允许未登录用户访问，不强制跳转登录
  onError: (errorInfo: ErrorInfo) => {
    // HeroUI toast
    toast.danger('操作失败', {
      description: errorInfo.message,
      timeout: 3000,
    });
  },
});

// 导出 Providers 组件（包含 Toast.Provider 和 ThemeProvider）
export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <>
      <ThemeProvider>
        <Toast.Provider placement="top" />
        <BaseProviders>{children}</BaseProviders>
      </ThemeProvider>
    </>
  );
}

